module.exports = __webpack_public_path__ + "img/htg.7dbfe9af.jpg";